/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './customer-footer.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/translations/translate.directive';
import * as i3 from '../../../../app/shared/translations/translations.service';
import * as i4 from '../../../../app/shared/settings.service';
import * as i5 from '@angular/router';
import * as i6 from '@angular/common';
import * as i7 from '../custom-menu/custom-menu.component.ngfactory';
import * as i8 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i9 from '../../../../app/auth/current-user';
import * as i10 from '../../../../app/shared/customer-footer/customer-footer.component';
const styles_CustomerFooterComponent:any[] = [i0.styles];
export const RenderType_CustomerFooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomerFooterComponent,data:{}});
export function View_CustomerFooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','meta']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['trans',
          '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4341760,(null as any),0,i2.TranslateDirective,[i1.ElementRef,i3.Translations,
          i4.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['Copyright © 2018, All Rights Reserved,'])),(_l()(),i1.ɵted((null as any),
          [' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,8).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i5.RouterLinkWithHref,
          [i5.Router,i5.ActivatedRoute,i6.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'custom-menu',
          [['position','footer']],[[2,'hidden',(null as any)]],(null as any),(null as any),
          i7.View_CustomMenuComponent_0,i7.RenderType_CustomMenuComponent)),i1.ɵdid(245760,
          (null as any),0,i8.CustomMenuComponent,[i4.SettingsService,i9.CurrentUser],
          {position:[0,'position']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        const currVal_2:any = '/';
        _ck(_v,8,0,currVal_2);
        const currVal_5:any = 'footer';
        _ck(_v,12,0,currVal_5);
      },(_ck,_v) => {
        var _co:i10.CustomerFooterComponent = _v.component;
        const currVal_0:any = i1.ɵnov(_v,8).target;
        const currVal_1:any = i1.ɵnov(_v,8).href;
        _ck(_v,7,0,currVal_0,currVal_1);
        const currVal_3:any = _co.settings.get('branding.site_name');
        _ck(_v,9,0,currVal_3);
        const currVal_4:any = i1.ɵnov(_v,12).shouldHide;
        _ck(_v,11,0,currVal_4);
      });
}
export function View_CustomerFooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'customer-footer',
      [['id','customer-footer']],(null as any),(null as any),(null as any),View_CustomerFooterComponent_0,
      RenderType_CustomerFooterComponent)),i1.ɵdid(49152,(null as any),0,i10.CustomerFooterComponent,
      [i4.SettingsService],(null as any),(null as any))],(null as any),(null as any));
}
export const CustomerFooterComponentNgFactory:i1.ComponentFactory<i10.CustomerFooterComponent> = i1.ɵccf('customer-footer',
    i10.CustomerFooterComponent,View_CustomerFooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2N1c3RvbWVyLWZvb3Rlci9jdXN0b21lci1mb290ZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2N1c3RvbWVyLWZvb3Rlci9jdXN0b21lci1mb290ZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvY3VzdG9tZXItZm9vdGVyL2N1c3RvbWVyLWZvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2N1c3RvbWVyLWZvb3Rlci9jdXN0b21lci1mb290ZXIuY29tcG9uZW50LnRzLkN1c3RvbWVyRm9vdGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbnRhaW5lclwiPlxyXG4gICAgPGRpdiBjbGFzcz1cIm1ldGFcIj48c3BhbiB0cmFucz5Db3B5cmlnaHQgJmNvcHk7IDIwMTgsIEFsbCBSaWdodHMgUmVzZXJ2ZWQsPC9zcGFuPiA8YSBbcm91dGVyTGlua109XCInLydcIj57e3NldHRpbmdzLmdldCgnYnJhbmRpbmcuc2l0ZV9uYW1lJyl9fTwvYT48L2Rpdj5cclxuICAgIDxjdXN0b20tbWVudSBwb3NpdGlvbj1cImZvb3RlclwiPjwvY3VzdG9tLW1lbnU+XHJcbjwvZGl2PiIsIjxjdXN0b21lci1mb290ZXI+PC9jdXN0b21lci1mb290ZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUF1QiwyQ0FDbkI7VUFBQTtVQUFBLGdCQUFrQjtVQUFBO2FBQUE7NEJBQUEsK0JBQVk7VUFBQSw2Q0FBa0Q7VUFBQSxRQUFDO1VBQUE7WUFBQTtZQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBO1VBQUEsZUFBc0Isd0NBQWdEO1VBQUEsYUFDdko7VUFBQTt5RUFBQSxVQUFBO1VBQUE7VUFBQSx5Q0FBNkM7O1FBRHVDO1FBQUgsV0FBRyxTQUFIO1FBQ3BFO1FBQWIsWUFBYSxTQUFiOzs7UUFEaUY7UUFBQTtRQUFBLFdBQUEsbUJBQUE7UUFBc0I7UUFBQTtRQUN2RztRQUFBLFlBQUEsU0FBQTs7OztvQkNGSjtNQUFBO3dDQUFBLFVBQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/customer-footer/customer-footer.component.ngfactory.ts